'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _FactboxHeader = require('./FactboxHeader');

var _FactboxHeader2 = _interopRequireDefault(_FactboxHeader);

var _FactboxFooter = require('./FactboxFooter');

var _FactboxFooter2 = _interopRequireDefault(_FactboxFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTON = 'button';
var HEADER = 'header';
var NONE = 'none';

var Factbox = function Factbox(_ref) {
    var _classnames;

    var isExpanded = _ref.isExpanded,
        title = _ref.title,
        children = _ref.children,
        onToggleExpanded = _ref.onToggleExpanded,
        theme = _ref.theme,
        expandBy = _ref.expandBy,
        i18n = _ref.i18n,
        attributes = _ref.attributes,
        identifier = _ref.identifier;

    var wrapperClasses = (0, _classnames3.default)(theme.root, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.rootIsExpanded, isExpanded), (0, _defineProperty3.default)(_classnames, theme.rootIsCollapsed, !isExpanded), (0, _defineProperty3.default)(_classnames, theme.rootButtonToggleable, expandBy === BUTTON), (0, _defineProperty3.default)(_classnames, theme.rootHeaderToggleable, expandBy === HEADER), _classnames));

    var contentId = 'factContent' + identifier;

    var header = void 0;
    var footer = void 0;

    switch (expandBy) {
        case BUTTON:
            header = _react2.default.createElement(_FactboxHeader2.default, { title: title, theme: theme, i18n: i18n, attributes: attributes });
            footer = _react2.default.createElement(_FactboxFooter2.default, {
                theme: theme,
                onToggleExpanded: onToggleExpanded,
                isExpanded: isExpanded,
                contentId: contentId,
                i18n: i18n,
                attributes: attributes
            });
            break;
        case HEADER:
            header = _react2.default.createElement(_FactboxHeader2.default, {
                title: title,
                isExpanded: isExpanded,
                onToggleExpanded: onToggleExpanded,
                theme: theme,
                contentId: contentId,
                i18n: i18n,
                attributes: attributes
            });
            break;
        case NONE:
        default:
            header = _react2.default.createElement(_FactboxHeader2.default, { title: title, theme: theme, i18n: i18n, attributes: attributes });
            break;
    }

    return _react2.default.createElement(
        'aside',
        { className: wrapperClasses, 'data-test-tag': '@spp/ui-factbox' },
        header,
        _react2.default.createElement(
            'div',
            { className: theme.body, id: contentId, 'aria-hidden': !isExpanded },
            children
        ),
        footer
    );
};

Factbox.propTypes = {
    attributes: _propTypes2.default.func,
    title: _propTypes2.default.shape({
        value: _propTypes2.default.string
    }).isRequired,
    children: _propTypes2.default.node.isRequired,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string,
        rootIsExpanded: _propTypes2.default.string,
        rootIsCollapsed: _propTypes2.default.string,
        streamer: _propTypes2.default.string,
        title: _propTypes2.default.string,
        header: _propTypes2.default.string,
        body: _propTypes2.default.string,
        button: _propTypes2.default.string,
        footer: _propTypes2.default.string,
        rootButtonToggleable: _propTypes2.default.string,
        headerClickable: _propTypes2.default.string,
        rootHeaderToggleable: _propTypes2.default.string
    }),
    isExpanded: _propTypes2.default.bool.isRequired,
    onToggleExpanded: _propTypes2.default.func.isRequired,
    expandBy: _propTypes2.default.oneOf([HEADER, BUTTON, NONE]),
    i18n: _propTypes2.default.shape({
        heading: _propTypes2.default.string,
        readMore: _propTypes2.default.string,
        readLess: _propTypes2.default.string
    }),
    identifier: _propTypes2.default.string.isRequired
};

Factbox.defaultProps = {
    attributes: function attributes() {
        return {};
    },
    theme: {},
    isExpanded: false,
    expandBy: NONE,
    i18n: {
        heading: 'Facts',
        readMore: 'Read more',
        readLess: 'Read less'
    }
};

exports.default = Factbox;
//# sourceMappingURL=Factbox.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-factbox/lib/cjs/Factbox.js
 ** module id = 511
 ** module chunks = 1
 **/